export const letterSlide = {
    initial:{
        x: "-100%",
        scale: .5,
        opacity: 0
    },
    animate:{
        x: 0,
        scale: 1,
        opacity: 1,
        rotate: [20, 10, 0],
        transition:{
            duration: 1,
            ease: 'easeOut',
            type: 'spring'
        }
    }
}